module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'require(\'amd-loader\');\nconst test = require(\'ava\');\nvar Cooling = require(\'./Cooling\');\n\nclass Source {\n	constructor(T) {\n		this.T = T;\n	}\n\n	getTemperature() {\n		return this.T;\n	}\n}\n\ntest("Source mock", t => {\nlet src = new Source(298);\nt.is(src.getTemperature(), 298);\n});\n\ntest("Cooling", t => {\n	let cooling = new Cooling();\n	t.deepEqual(cooling.power, -0.50, "Check the default cooling power.");\n});\n\ntest("Cooling with a different power", t => {\n	let cooling = new Cooling(-0.25);\n	t.deepEqual(cooling.power, -0.25, "Check setting a cooling power.");\n});\n';

}
return __p
}